import React, { lazy } from 'react';
import { Field } from 'formik';
import { behavioursMap, severityMap } from './config';

const layout = window.$environment?.CURRENT_LAYOUT;
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));

const RenderComponent = (props) => {
  const {
    values,
    handleEdit,
    errors,
    isNotValid,
    validateForm,
    customProps: { i18n, Styled },
    submitAction,
    cancelAction,
  } = props;

  const showError = (field, validationErrors, isNotValid, apiError) => {
    if (validationErrors[field] && !isNotValid) {
      return <Message type="error" message={errors[field]} />;
    }
    if (apiError?.[field]) {
      return <Message type="error" message={apiError[field]} />;
    }
  };

  return (
    <>
      <Styled.Wrapper>
        <div className="section-wrapper">
          <div className="scoreSection">
            <div className="sections">
              <SubHeader text={i18n.t('Behavior Scores')} className="subheaderSection companyTitle" variant="h2" />
              <div className="companyForm firstRow">
                {behavioursMap.map((ele) => {
                  return (
                    <FormStyle.FieldsWrapper>
                      <Label htmlFor={ele.label.toLowerCase()} variant="body1">
                        {i18n.t(ele.label)}
                      </Label>
                      <FormStyle.TextWrapper>
                        <Field
                          name={ele.label.toLowerCase()}
                          id={ele.label.toLowerCase()}
                          handleOnChange={(event) => handleEdit(event, { field: ele.label.toLowerCase() })}
                          as={Input}
                          placeholder={i18n.t(ele.placeHolder)}
                          value={values[ele.label.toLowerCase()]}
                          type="text"
                        />
                        {showError(ele.label.toLowerCase(), errors, isNotValid)}
                      </FormStyle.TextWrapper>
                    </FormStyle.FieldsWrapper>
                  );
                })}
              </div>
            </div>
            <div className="sections">
              <SubHeader text={i18n.t('Severity Level Scores')} className="subheaderSection companyTitle" variant="h2" />
              <div className="companyForm firstRow">
                {severityMap.map((ele) => {
                  return (
                    <FormStyle.FieldsWrapper>
                      <Label htmlFor={ele.valueMap.toLowerCase()} variant="body1">
                        {i18n.t(ele.label)}
                      </Label>
                      <FormStyle.TextWrapper>
                        <Field
                          name={ele.valueMap.toLowerCase()}
                          id={ele.valueMap.toLowerCase()}
                          handleOnChange={(event) => handleEdit(event, { field: ele.valueMap.toLowerCase() })}
                          as={Input}
                          placeholder={i18n.t(ele.placeHolder)}
                          value={values[ele.valueMap.toLowerCase()]}
                          type="text"
                        />
                        {showError(ele.valueMap.toLowerCase(), errors, isNotValid)}
                      </FormStyle.TextWrapper>
                    </FormStyle.FieldsWrapper>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="buttonSection">
            <FormStyle.ButtonsWrapper className="submitSection">
              <Button
                className="buttonStyle"
                type="reset"
                label={i18n.t('common.cancel')}
                onClick={(e) => {
                  cancelAction();
                }}
              />
              <Button
                id="companyInfoSubmit"
                type="submit"
                label={i18n.t('Save')}
                onClick={() => {
                  const validateResponse = validateForm();
                  validateResponse.then((data) => submitAction(data));
                }}
              />
            </FormStyle.ButtonsWrapper>
          </div>
        </div>
      </Styled.Wrapper>
    </>
  );
};

export default RenderComponent;
